(()=>{
function navigationIntent(question){
  if(/(?:don't|do not|ikke|inte)\s+(?:open|show|åbn|åbne|vis|öppna|visa)|(?:vis|åbn|visa|öppna)\s+(?:ikke|inte)|show me how|vis mig hvordan|visa mig hur/i.test(question))return false;
  return /\b(?:show|open|browse|take me|go to|navigate|vis|åbn|aabn|gå til|visa|öppna|oppna)\b/i.test(question);
}
function safeStorePath(value){
  if(typeof value!=='string'||value.length>700)return null;
  let url;try{url=new URL(value,'https://ebits.dk');}catch{return null;}
  if(url.origin!=='https://ebits.dk'||url.username||url.password)return null;
  if(!/^(?:\/(?:en|sv|da))?(?:\/|\/products\/[a-z0-9-]+|\/collections\/[a-z0-9-]+|\/pages\/(?:kontakt|om-os|it-konsultation)|\/blogs\/ebits-blogs(?:\/[a-z0-9-]+)?|\/search|\/cart)$/.test(url.pathname))return null;
  const allowed=new URLSearchParams();
  for(const [k,v] of url.searchParams){if(k==='q'&&v.length<=140)allowed.set(k,v);else if(k==='type'&&v==='product')allowed.set(k,v);else if(k==='variant'&&/^\d+$/.test(v))allowed.set(k,v);else if(k==='view'&&/^(?:meshtastic|magazine-(?:meshtastic|bluetooth|elektronik)-(?:da|en|sv))$/.test(v))allowed.set(k,v);else return null;}
  return url.pathname+(allowed.size?'?'+allowed.toString():'')+(/^#[a-zA-Z0-9_-]*$/.test(url.hash)?url.hash:'');
}
function chooseNavigation(suggestion,input,products){
  if(!navigationIntent(input.question))return null;
  if(/cheap(?:er|est)|billigst|billigere|billigast|billigare/i.test(input.question)){
    const referents=input.context.recentProducts||[];
    const relevant=referents.length?products.filter(p=>referents.includes(p.handle)):products;
    const cheapest=relevant.flatMap(p=>p.variants.filter(v=>v.available).map(v=>({p,v}))).sort((a,b)=>a.v.price-b.v.price)[0];
    if(cheapest)return {url:'/products/'+cheapest.p.handle+'?variant='+cheapest.v.id,title:cheapest.p.title};
  }
  if(!suggestion||typeof suggestion!=='object')return null;
  if(suggestion.kind==='product'){
    const product=products.find(p=>p.handle===suggestion.handle);return product?{url:'/products/'+product.handle,title:product.title}:null;
  }
  if(suggestion.kind==='search'&&typeof suggestion.query==='string'){
    const query=suggestion.query.trim().slice(0,100);if(!query)return null;
    return {url:'/search?q='+encodeURIComponent(query)+'&type=product',title:query};
  }
  if(suggestion.kind==='guide'&&['meshtastic','bluetooth','elektronik'].includes(suggestion.topic))return {url:'/blogs/ebits-blogs?view=magazine-'+suggestion.topic+'-'+input.language,title:'eBits Akademi · '+suggestion.topic};
  if(suggestion.kind==='contact')return {url:'/pages/kontakt',title:'Kontakt · eBits'};
  if(suggestion.kind==='about')return {url:'/pages/om-os',title:'Om eBits'};
  if(suggestion.kind==='help')return {url:'/pages/it-konsultation',title:'Projekthjælp'};
  if(suggestion.kind==='cart')return {url:'/cart',title:'Kurv'};
  if(suggestion.kind==='home')return {url:'/',title:'eBits'};
  return null;
}

function isStoreOrigin(origin,currentOrigin){
  return origin===currentOrigin||['https://ebits.dk','https://www.ebits.dk','https://ebits.se','https://www.ebits.se'].includes(origin);
}
function localizedStorePath(value,root='/',language='da'){
  if(typeof value!=='string'||!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?$/i.test(root))return null;
  let parsed;try{parsed=new URL(value,'https://ebits.dk');}catch{return null;}
  if(!isStoreOrigin(parsed.origin)||parsed.username||parsed.password)return null;
  const safe=safeStorePath(parsed.pathname+parsed.search+parsed.hash);if(!safe)return null;
  const target=new URL(safe,'https://ebits.dk');
  target.pathname=target.pathname.replace(/^\/(?:da|en|sv)(?=\/|$)/,'')||'/';
  const view=target.searchParams.get('view');
  if(view&&/^magazine-(?:meshtastic|bluetooth|elektronik)-(?:da|en|sv)$/.test(view)&&['da','en','sv'].includes(language))target.searchParams.set('view',view.replace(/-(?:da|en|sv)$/,'-'+language));
  return root+target.pathname.replace(/^\//,'')+target.search+target.hash;
}
globalThis.RasmineNavigation={safeStorePath,localizedStorePath,isStoreOrigin};
})();
